import React from 'react'

import styled from 'styled-components'
import { Notification, NotificationResource } from 'shared/types/notifications'
import moment from 'moment'
import { Avatar } from 'antd'

const NOTIFICATION_RESOURCE_FS_VERSION_TYPE = 'fs_version'

interface NotificationItemProps {
  notification: Notification;
  onClick: (notification: Notification) => void;
  onMouseEnter?: (e: React.MouseEvent) => void;
  onMouseLeave?: (e: React.MouseEvent) => void;
  className?: string;
}

export const NotificationItem: React.FC<NotificationItemProps> = ({
  notification,
  onClick,
  onMouseEnter,
  onMouseLeave,
  className
}) => {
  const { messages, created, is_viewed, initiator_name } = notification
  const resources = notification?.resources || []
  const notificationInitiatorAvatar = notification.avatarUrl

  const getAssetName = (resources: NotificationResource[]) => {
    if(!resources.length) return ''
    return resources.find(item => item.type === NOTIFICATION_RESOURCE_FS_VERSION_TYPE)?.name || ''
  }

  const getMessage = () => {
    const ruMessage = messages.find(msg => msg.lang === 'ru')
    return ruMessage || messages[0]
  }

  const message = getMessage()
  const assetName = getAssetName(resources)

  // const handleMarkAsRead = (e: React.MouseEvent) => {
  //   e.stopPropagation()
  //   if (!is_viewed) {
  //     onMarkAsRead(id)
  //   }
  // }

  return (
    <SListItem
      onClick={() => onClick(notification)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={className}
    >
      <SAvatarContainer>
        <SAvatar
          $hasAvatar={!!notificationInitiatorAvatar}
          src={notificationInitiatorAvatar || undefined}
        >

          {initiator_name.charAt(0)}

          <STypeIconContainer>
            {
              notification.type === 'mention_in_comment' && <STypeImg src="/icons/mentioned.svg" />
            }

            {
              notification.type === 'new_comment' && <STypeImg src="/icons/commented.svg" />
            }

            {
              notification.type === 'reply_comment' && <STypeImg src="/icons/reply.svg" />
            }
          </STypeIconContainer>
        </SAvatar>
      </SAvatarContainer>

      <SNotificationContent>
        <SAuthorName>
          {initiator_name}
        </SAuthorName>

        <SInfoRow>

          <SInfoAssetLabel>
            {
              notification.type === 'mention_in_comment' && 'Mentioned you'
            }

            {
              notification.type === 'reply_comment' && 'Reply'
            }

            {
              notification.type === 'new_comment' && 'Comments'
            }

          </SInfoAssetLabel>

          {assetName && (
            <SInfoAssetSeparator>
              {'•'}
            </SInfoAssetSeparator>
          )}

          <SInfoAssetName>
            {assetName && (
              <SAssetNameText>
                {assetName}
              </SAssetNameText>
            )}
          </SInfoAssetName>
        </SInfoRow>

        <SMessageText>
          {message.text}
        </SMessageText>
      </SNotificationContent>

      <SRightContent>
        <SDate>
          {moment(created).fromNow()}
        </SDate>


        <SUnreadDotContainer>
          {!is_viewed && (
            <SUnreadDot />
          )}
        </SUnreadDotContainer>
      </SRightContent>
    </SListItem>
  )
}

const SListItem = styled.div`
  padding: 12px 24px;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  
  &:hover {
    background-color: #f5f5f5;
  }
`
const SAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
`

const SAvatar = styled(Avatar)<{ $hasAvatar?: boolean }>`
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${props => props.$hasAvatar ? 'transparent' : '#00000040'};
  font-size: 14px;
  color: #FFFFFF;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  position: relative;
`

const STypeIconContainer = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  border-radius: 50%;
  position: absolute;
  right: -7px;
  bottom: -6px;
`

const STypeImg = styled.img`
  width: 14px;
  height: 14px;
`

const SNotificationContent = styled.div`
  margin-left: 16px;
  flex: 1;
`

const SAuthorName = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: #000000E0;
`

const SInfoRow = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.88);
  width: 100%;
  max-width: 380px;
`

const SMessageText = styled.div`
  margin-top: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #000000A6;
  word-break: break-all;
`

const SRightContent = styled.div`
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
`

const SDate = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #00000073;
`

const SUnreadDotContainer = styled.div`
  margin-left: 8px;
  margin-top: 2px;
  width: 6px;
  height: 6px;
`

const SUnreadDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #FF4D4F;
`

const SAssetNameText = styled.span`
  font-size: 12px;
  font-weight: 400;
`

const SInfoAssetLabel = styled.div`
  white-space: nowrap;
`

const SInfoAssetName = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

`

const SInfoAssetSeparator = styled.div`
  margin: 0 4px;
`

const SAvatarImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
`
